<div class="d-flex justify-content-between gap-2">
  <div class="filter-title">{{ sectionTitle }}</div>
  <button class="primary-paddingless-text-button" type="button" (click)="resetClicked.emit()" i18n>Reset</button>
</div>
